const template = `

    <table align="center" cellpadding="0" cellspacing="0" width="600"  style="border-collapse: collapse;">
        <tr>
            <td>
                <img height="70" src="https://www.fcamara.com.br/images/marcas-mercados/slide/omnik.png">
            </td>
        </tr>
        <tr>
            <td align="center" height='100px'>
                <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>TERMO DE AUTORIZAÇÃO PARA UTILIZAÇÃO DE DADOS</strong></p>
            </td>
        </tr>
        <tr>
            <td>
                <p>
                    Pelo presente Termo de autorização para a utilização de dados pessoais, de um lado {{consultantname}}, CPF nº {{consultantcpf}}, Carteira de Identidade nº {{consultantrg}}, residente e domiciliado {{consultantaddress}}, nº {{consultantnumber}}, CEP. {{consultantcep}}, {{consultantcity}}/{{consultantstate}}, determinada como parte REVELADORA, e de outro,
                </p>
                <p>
                     <strong>GRUPO FCAMARA CONSULTORIA E FORMAÇÃO EM INFORMATICA LTDA</strong>, com sede na Rua Bela Cintra, nº 986, 2º andar, Bairro Consolação, CEP 01415-000 – São Paulo - SP, inscrita no CNPJ sob no. 03.775.758/0001-90, em conjunto com as suas empresas conglomeradas e/ou de seu mesmo Grupo Econômico, resta determinada como parte <strong>RECEPTORA.</strong>
                </P>

                <p>
                    Considerando que as <strong>PARTES:</strong>
                </p>
                <p>
                    a)	Têm uma relação de prestação de serviços ou, em caso de profissional CLT, uma relação de trabalho;
                </p>
                <p>
                    b)	Precisam operar dados pessoais durante a relação supramencionada e pelo período de até 5 (cinco) anos após o seu fim (de acordo com a legislação aplicável);
                </p>
                <p>
                    c)	Visam garantir o cumprimento da Lei 13.709.2018 (Lei Geral de Proteção de Dados), bem como à GDPR e o Regulamento (UE) nº 2016/679 (quando aplicável).
                </p>

                <p>
                    As Partes formalizam o presente Termo, de livre e espontânea vontade, sendo certo que a REVELADORA leu o termo e pôde expressar a sua real vontade por meio dos canais oficiais do Grupo e mediante as cláusulas que seguem:
                </p>


                <p>
                    <strong>CLÁUSULA PRIMEIRA – DO OBJETO</strong>
                </p>
                <p>
                    <strong>1.1.</strong> Este documento visa registrar a manifestação livre e inequívoca de vontade, pela qual a REVELADORA concorda com o tratamento de seus dados pessoais para as finalidades específicas abaixo previstas, pemitindo que a RECEPTORA utilize de seus dados pessoais, para que realize o tratamento (conforme aplicável) dos dados com os fins de:
                </p>
                <p>
                    I. Propaganda de produtos ou serviços, para fins de parcerias, com ofertas de oportunidades, como por exemplo: Allya e Creditas;
                </p>
                <p>
                    II. Divulgação de palestras vinculadas ao Grupo FCamara;
                </p>
                <p>
                    III. Veiculação em mídia, como por exemplo em caso de: premiações, concursos, novidades, destaques;
                </p>
                <p>
                    IV. Envio de e-mails marketing internos e externos e demais benefícios corporativos;
                </p>
                <p>
                    V. Contatos e relacionamento comercial.
                </p>

                <p>
                    <strong>1.1.1.</strong> O uso dos dados pessoais da REVELADORA também poderá ser feito para elaboração de relatórios, pesquisas de mercado, contratos e cobranças, comunicação interna (com foto, nome e contato de telefone em e-mail), mensagem de “boas vindas” em grupos de WhatsApp ou Teams, e-mail e demais comunicações nas mídias sociais.
                </p>
                <p>
                    <strong>1.2.</strong> Os presentes termos são passíveis de alteração por ambas as Partes, a qualquer momento, por meio de aditivo.
                </p>
                <p>
                    <strong>1.3.</strong> Ao manifestar sua aceitação ao presente termo, a REVELADORA consente e concorda que RECEPTORA, tome decisões referentes à veiculação de seus dados pessoais, bem como realize o tratamento deles, envolvendo operações como as que se referem a: coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.
                </p>
                <p>
                    <strong>1.4.</strong> Entre os dados pessoais a serem utilizados, e conforme sua aplicabilidade, estão:
                </p>
                <ul type="disc">
                    <li>Nome completo; RG; CPF; Data de nascimento; </li>
                    <li>Chave PIX não aleatória; </li>
                    <li>Curriculum vitae, formação acadêmica e experiência profissional prévia;</li>
                    <li>Número e imagem da Carteira de Identidade (RG ou CNH);</li>
                    <li>Número e imagem do Cadastro de Pessoas Físicas (CPF);</li>
                    <li>Imagem Pessoal de identificação (e/ou Fotografia) / Vídeo;</li>
                    <li>Endereço completo;</li>
                    <li>Números de telefone, WhatsApp e endereços de e-mail;</li>
                    <li>Fotografias, para divulgação;</li>
                    <li>Valor recebido a título de prestação de serviços;</li>
                    <li>Número de telefone celular;</li>
                    <li>Dados de autenticação; biometria; localização.</li>
                </ul>
                <p>
                    <strong>1.5.</strong> As informações ainda poderão ser utilizadas, quando e se aplicável, para:
                </p>
                <p>
                    a)	Confecção de crachás de acesso, gerenciamento de projetos, processo de reembolsos e demais procedimentos internos, como a necessidade de inscrição do profissional (se e quando aplicável) aos registros pertinentes ao Departamento Pessoal;
                </p>
                <p>
                    b)	Terceiros, como por exemplo: a seguradora; à bandeira e detentora de cartão premiação; fornecedora do vale transporte, vale refeição e/ou vale alimentação; parceiros de crédito consignado; rede de descontos corporativos; dentre outros sistemas, parcerias e/ou benefícios internos;
                </p>
                <p>
                    c)	Eventuais auditorias; questões fiscais; contábeis; regulatórias e profissionais. Bem como, para  alimentar sistemas internos, atos de marketing e divulgação dos profissionais do Grupo FCamara, perante os seus clientes e na mídia em geral, em propostas e comunicações comerciais, artigos, informes e dados do website, ainda, através de e-mail e redes sociais.
                </p>
                <p>
                    <strong>1.6.</strong> Demais dados e documentos específicos à contratação, estarão disponíveis de conhecimento por meio das políticas do Grupo, supramencionadas.
                </p>



                <p>
                    <strong>CLÁUSULA SEGUNDA – DAS DISPOSIÇÕES GERAIS</strong>
                </p>
                <p>
                    <strong>2.1.</strong> Este termo é firmado com o intuito de evitar a divulgação e utilização não autorizada dos dados trocados entre as PARTES, e demais parceiros e/ou fornecedores.
                </p>
                <p>
                    <strong>2.2.</strong> A RECEPTORA dispensará as informações confidenciais da REVELADORA com o mesmo zelo e cuidado com que trata os seus próprios dados e deverá mantê-las em local seguro, com acesso limitado, apenas às pessoas autorizadas.
                </p>
                <p>
                    <strong>2.3.</strong> Em caso de qualquer falha na segurança das informações confidenciais, a RECEPTORA comunicará em até 48 (quarenta e oito) horas úteis, contadas do conhecimento do fato, à parte REVELADORA, o que não presume a sua responsabilidade.
                </p>
                <p>
                    <strong>2.4.</strong> A parte RECEPTORA durante o tratamento de dados da REVELADORA, observará os princípios da finalidade, adequação, transparência, livre acesso, segurança, prevenção e não discriminação no tratamento dos dados.
                </p>
                <p>
                    <strong>2.5.</strong> A parte REVELADORA poderá solicitar por escrito, via e-mail ou correspondência com aviso de recebimento, a qualquer momento, que sejam atualizados ou eliminados os seus dados pessoais não anonimizados, salvo o que for necessário para fins contábeis, societário, trabalhista, previdenciário, fiscal, dentre outras obrigações legais imputadas à RECEPTORA, pelo prazo legal necessário.
                </p>
                <p>
                    <strong>2.6.</strong> Não haverá qualquer remuneração ou indenização devida à REVELADORA pelo uso dos dados na forma prevista neste Termo. Caso, a REVELADORA utilize dos dados pessoais em questão de forma prejudicial, deverá ser apurada a sua responsabildiade em devido processo legal, que se limitará ao valor mensal do Contrato de Prestação de Serviços entre as Partes e, na falta deste, ao Contrato de Trabalho.
                </p>
                <p>
                    <strong>2.7.</strong> Para o conhecimento das informações relativas à Privacidade de Dados  e Segurança da Informação  da Organização, principalmente para que a REVELADORA tenha ciência de seus direitos, declara e garante que leu a política disponibilizada no website oficial da RECEPTORA, por meio do link <a href="https://www.fcamara.com.br">https://www.fcamara.com.br</a>.
                </p>

                <p>
                    <strong>CLÁUSULA TERCEIRA – DO FORO</strong>
                </p>
                <p>
                    <strong>3.1.</strong> Para dirimir quaisquer dúvidas oriundas do presente Termo, fica eleito o Foro de Arbitragem do Estado de São Paulo, com renúncia expressa a qualquer outro, por mais privilegiado que seja.
                </p>
                <p>
                    <strong>3.2.</strong> E por estarem justas e acordadas, as Partes assinam este instrumento mediante plataforma eletrônica DocuSign, em conjunto de 02 (duas) testemunhas, abaixo arroladas.
                </p>
                <br>
            </td>
        </tr>
        <tr>
            <td align="center" height='60px'>
                <p style="text-align: center; margin-top: 50px;">
                    <strong>São Paulo</strong>, {{contractstart}}
                </p>
            </td>
        </tr>
        <tr>
            <td align="center" height='60px'>
                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        <strong>GRUPO FCAMARA CONSULTORIA E FORMAÇÃO EM INFORMATICA LTDA<br>
                        RECEPTORA</strong>
                    </span>
                </p>
            </td>
        </tr>
        <tr>
            <td align="center" height='60px'>
                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        <strong>OMNIK SERVIÇOS DE TECNOLOGIA DA INFORMAÇÃO LTDA<br>
                        ANUENTE</strong>
                    </span>
                </p>
            </td>
        </tr>
        <tr>
            <td align="center" height='60px'>


            <p style="text-align: center; margin-top: 80px;">
            <span>
            ___________________________________________________<br>
            {{consultantname}}<br>
            <br><strong>REVELADORA</strong>
            </span>
            </p>

            <!-- TESTEMUNHASSSS -->
            <p style="margin-top: 50px;">
                <strong>TESTEMUNHAS</strong>
            </p>
            <div class="testemunhas" style="margin: 0; text-align: left;">
                <table style="width: 100%;">
                    <thead></thead>
                    <tbody>
                        <tr>
                            <td style="width: 50%;">
                                <span>
                                1. __________________________<br>
                                Nome:<br>
                                </span>
                                </td>
                                <td style="width: 50%;">
                                <span>
                                2. __________________________<br>
                                Nome:<br>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
            <div id="pageFooter"></div>
            </div>
            </td>
        </tr>
    </table>
`;

export default template;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/docusignDocumentTemplates/termOfConfidentialityOmnik.ts